'use client'

import PropTypes from 'prop-types'
import MUIButton from '@mui/material/Button'

export const TextLinkButton = ({ title = 'Click me', sx, onClick, isActive = true }) => {
  const handleClick = (e) => {
    if (isActive && onClick) onClick(e)
  }

  return (
    <MUIButton
      data-testid="TextLinkButton"
      variant="text"
      sx={{
        padding: '10px 0',
        display: 'inline-block',
        width: '160px',
        textTransform: 'none',
        textDecoration: isActive ? 'underline' : 'none',
        color: isActive ? 'secondary.dark' : 'text.primary',
        '&:hover': {
          textDecoration: isActive ? 'underline' : 'none',
          backgroundColor: 'transparent',
          color: isActive ? 'secondary.light' : 'text.primary',
          cursor: isActive ? 'pointer' : 'default'
        },
        ...sx
      }}
      onClick={handleClick}
    >
      {title}
    </MUIButton>
  )
}

TextLinkButton.propTypes = {
  title: PropTypes.node,
  sx: PropTypes.object,
  onClick: PropTypes.func,
  isActive: PropTypes.bool
}
